import { render } from "./StudentDeviceRgistration.vue?vue&type=template&id=b5e605f0&scoped=true"
import script from "./StudentDeviceRgistration.vue?vue&type=script&lang=js"
export * from "./StudentDeviceRgistration.vue?vue&type=script&lang=js"

import "./StudentDeviceRgistration.vue?vue&type=style&index=0&id=b5e605f0&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5e605f0"]])

export default __exports__